export const FasesProyecto = ({setVista, vista, data, envioImagen, envioDoc}) => {
    const fases = [
        {codigo: 1, nombre: 'Idea', color: ' bg-gray-900 ', descripcion: 'Registro de la necesidad o problema que motiva el proyecto'},
        {codigo: 2, nombre: 'Inicio', color: ' bg-gray-800 ', descripcion: 'Objetivo, alcance e interesados'},
        {codigo: 3, nombre: 'Análisis', color: ' bg-gray-700 ', descripcion: 'Requisitos funcionales y no funcionales'},
        {codigo: 4, nombre: 'Desglose (EDT)', color: ' bg-gray-600 ', descripcion: 'Estructuración del proyecto'},
        {codigo: 5, nombre: 'Desarrollo y actividades', color: ' bg-gray-500 ', descripcion: 'Seguimiento del progreso'},
        {codigo: 6, nombre: 'Entrega y cierre', color: ' bg-gray-400 ', descripcion: 'Validación y cierre administrativo'},
        {codigo: 7, nombre: (data.estado === 9 ? 'Rechazar' : 'Rechazado'), color: ' bg-gray-400 ', descripcion: 'Registro de motivo de rechazo ticket'},
    ]
    const estiloBoton = "lg:min-w-[80px] lg:max-w-[120px] lg:h-[90%] lg:text-xs rounded   w-full h-[100px] p-1 "
    const onclickButton =(codigo) =>{
        setVista(codigo)
        envioImagen({ tipo: 'Reiniciar' })
        envioDoc({ tipo: 'Reiniciar' })
    }
    return(
        <>
        {
            fases.map((fase,i) => {
                return <button
                    key={i}
                    className={`${estiloBoton} ${vista === fase.codigo ?  ' bg-blue-700 ' : `${(data.identificador === 0 && (i > 1) )? '' : 'hover:bg-[#8dbe55]'}  ${fase.color} ` }
                    ${(!data.codigo && (i > 0 )) ?  ' hidden ' : ( data.estado === 35 ? ( i === 0 || i === 6 ? '' : ' hidden') : (data.estado !== 9 && i === 6 ? ' hidden' : ''))}`}
                    disabled={data.codigoIdentificador === 0 && (i > 1) && (i < 5 )  ?  true : false   }
                    onClick={() => onclickButton(fase.codigo)}
                >
                    <div className="lg:overflow-hidden lg:text-ellipsis lg:whitespace-nowrap lg:w-min-[65px] lg:w-max-[85px] max-h-[50px] whitespace-pre overflow-hidden text-ellipsis ">
                        <label className="text-xl font-semibold lg:text-xs ">{fase.nombre}</label>
                    </div>
                    <div className="text-xs lg:hidden max-h-[50px] whitespace-nowrap text-ellipsis overflow-hidden">
                        <label>{fase.descripcion}</label>
                    </div>
                </button>

            })
        }
        </>
    )

}